import { useState } from "react";
import { RenderEditItem, RenderEditImage } from "./RenderEdits";
import { iconRenderMapper, iconNameMapper } from "../../../util/iconMapper";

interface RenderSectionItemsProps {
  editModeEnabled: boolean;
  inputItems: any;
  enableImgs?: boolean;
  setImgAsBackground?: boolean;
  editToolsOutside?: boolean;
  enableIcons?: boolean;
  groupClass?: string;
  itemClass?: string;
  primaryColor?: string;
  saveAction?: (itemOverride?: any) => void;
}
// inputItems<value[], setter()>
export function RenderSectionItems({
  editModeEnabled,
  inputItems,
  enableImgs = false,
  setImgAsBackground = false,
  editToolsOutside = false,
  enableIcons = false,
  groupClass = "",
  itemClass = "",
  primaryColor = "",
  saveAction,
}: RenderSectionItemsProps) {
  if (!inputItems) {
    return <div />;
  }
  let itemCount = 0;
  function addItem() {
    const newItem = { index: itemCount, title: "", description: "" };
    inputItems.setter((val: any[]) => val.concat(newItem));
    saveAction?.();
  }

  function removeItem() {
    inputItems.setter((val: string | any[]) => val.slice(0, -1));
    itemCount -= 1;
    saveAction?.();
  }

  const renderItems = inputItems.value.map((item: any) => {
    itemCount += 1;
    return (
      <div key={itemCount}>
        <RenderSectionItem
          sectionItem={item}
          itemCount={itemCount}
          editModeEnabled={editModeEnabled}
          enableImgs={enableImgs}
          setImgAsBackground={setImgAsBackground}
          editToolsOutside={editToolsOutside}
          enableIcons={enableIcons}
          groupClass={groupClass}
          itemClass={itemClass}
          primaryColor={primaryColor}
          parentItems={inputItems}
          saveAction={saveAction}
        />
      </div>
    );
  });
  return (
    <>
      {renderItems}
      {editModeEnabled && (
        <>
          <div className="editBreak" />
          <div className="editButtonGroup">
            <button
              type="button"
              className="editButton"
              onClick={() => addItem()}
            >
              ➕ Add New Item
            </button>
            <button
              type="button"
              className="editButton"
              onClick={() => removeItem()}
            >
              ➖ Remove Last Item
            </button>
          </div>
        </>
      )}
    </>
  );
}

interface RenderSectionItemProps {
  editModeEnabled: boolean;
  sectionItem: any;
  itemCount?: number;
  enableImgs?: boolean;
  setImgAsBackground?: boolean;
  editToolsOutside?: boolean;
  enableIcons?: boolean;
  groupClass?: string;
  itemClass?: string;
  primaryColor?: string;
  parentItems?: any;
  saveAction?: (itemOverride?: any) => void;
}
// sectionItem{ value, description, img }
// parentItems Map<value[], setter()>
export function RenderSectionItem({
  editModeEnabled,
  sectionItem,
  itemCount = 0,
  enableImgs = false,
  setImgAsBackground = false,
  editToolsOutside = false,
  enableIcons = false,
  groupClass = "",
  itemClass = "",
  primaryColor = "",
  parentItems = undefined,
  saveAction,
}: RenderSectionItemProps) {
  const [myTitle, setMyTitle] = useState(sectionItem.title);
  const [myDescription, setMyDescription] = useState(sectionItem.description);
  const [myImg, setMyImg] = useState(sectionItem.img);
  const itemIcon = iconNameMapper(myTitle);

  // Save to parent
  const saveToParent = (imgOverride?: any) => {
    if (parentItems?.value && parentItems.value.length > 0) {
      const updatedParentItems = parentItems.value.map(
        (pItem: { index: any }) => {
          // Find matching index and update otherwise return existing value
          if (pItem.index === sectionItem.index) {
            return {
              index: sectionItem.index,
              title: myTitle,
              description: myDescription,
              img: imgOverride || myImg,
            };
          }
          return pItem;
        },
      );
      parentItems.setter(updatedParentItems);
    }
    saveAction?.();
  };
  return (
    <div
      className={`${groupClass && groupClass !== "" ? groupClass : "renderItem"}`}
      style={{
        backgroundImage: setImgAsBackground
          ? myImg && myImg !== "" && myImg !== "empty"
            ? `url('${myImg}')`
            : `radial-gradient( #f5f5f5 15%, #e3e3e3 75%)`
          : "",
      }}
    >
      {enableImgs && (
        <RenderEditImage
          inputSrc={{ value: myImg, setter: setMyImg }}
          altText={myTitle}
          editModeEnabled={editModeEnabled}
          itemClass={itemClass}
          setImgAsBackground={setImgAsBackground}
          editToolsOutside={editToolsOutside}
          saveAction={saveToParent}
        />
      )}
      <div className={itemClass}>
        <div className="renderItemText">
          {enableIcons && itemIcon && (
            <div className="renderItemIcon" style={{ color: primaryColor }}>
              {iconRenderMapper(itemIcon)}
            </div>
          )}
          <h3>
            <RenderEditItem
              inputItem={{ value: myTitle, setter: setMyTitle }}
              editModeEnabled={editModeEnabled}
              saveAction={saveToParent}
            />
          </h3>
          <p>
            <RenderEditItem
              inputItem={{ value: myDescription, setter: setMyDescription }}
              enableTextArea
              editModeEnabled={editModeEnabled}
              saveAction={saveToParent}
            />
          </p>
        </div>
      </div>
    </div>
  );
}
